import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=edb66ff6"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edb66ff6')) {
      api.createRecord('edb66ff6', component.options)
    } else {
      api.reload('edb66ff6', component.options)
    }
    module.hot.accept("./DataForm.vue?vue&type=template&id=edb66ff6", function () {
      api.rerender('edb66ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/brand/components/DataForm.vue"
export default component.exports